import React, { useState } from "react";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls } from "../../Utils/url";
import { getUser } from "../../Redux/Actions/Authentication";
import { connect } from "react-redux";

const FormComponent = ({ name, setState }) => {
  return (
    <input
      className="textInput"
      autoComplete="off"
      placeholder={name}
      onChange={v => setState(v.target.value)}
    />
  );
};

export const updateProfile = (
  firstname,
  lastname,
  email,
  token,
  getUser,
  setEdit
) => {
  ApiCall(
    "put",
    `${urls.User}?first_name=${firstname}&last_name=${lastname}&email=${email}`,
    null,
    "EditProfile",
    token,
    function(e) {
      getUser(e.data);
      setEdit(false);
    }
  );
};

const EditForm = ({ setEdit, token, getUser }) => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  return (
    <div className="container editPage">
      <FormComponent name={"نام"} setState={setFirstname} />
      <FormComponent name={"نام خانوادگی"} setState={setLastname} />
      <FormComponent name={"ایمیل"} setState={setEmail} />
      <div
        className={"LoginButton FormButton"}
        onClick={() =>
          updateProfile(firstname, lastname, email, token, getUser, setEdit)
        }
      >
        ثبت
      </div>
      <div className={"LoginButton DismissBtn"} onClick={() => setEdit(false)}>
        انصراف
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getUser: userInfo => dispatch(getUser(userInfo))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditForm);
